import axios from './interceptor'

// const BaseUrl = '/official-website-backend'
const BaseUrl = 'http://120.79.19.225:9019'

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    url = BaseUrl + url
    axios.get(url, params).then(
      (response) => {
        // 请求成功，但是统一对请求的结果进行判断
      //   if (response.returnCode.slice(-4) === '0000') {
      //     resolve(response)
      //   } else {
      //     reject(response.returnMsg)
      //   }
        resolve(response)
      },
      (err) => reject(err)
    )
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    url = BaseUrl + url
    axios.post(url, data).then(
      (response) => {
        // 请求成功，但是统一对请求的结果进行判断
        if (response.data.code.slice(-4) === '0000') {
          resolve(response)
        } else {
          reject(response.data.msg)
        }
        // resolve(response)
      },
      (err) => reject(err)
    )
  })
}



// WEBPACK FOOTER //
// ./src/https/request.js